import { Injectable } from '@angular/core';
import { Personimage } from '../model/personimage';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PersonimageService {
  personUrl:string = environment.apiUrl+'/person/';
  pi:Personimage;
  constructor(private http:HttpClient) { }

  addPersonImage(personimage:Personimage):Observable<Personimage>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const databody = JSON.stringify(personimage);
    //console.log('databody: '+databody);
    const postUrl = this.personUrl+personimage.personId+'/image';
    //console.log('posturl: '+postUrl);
    
    return this.http.post<any>(postUrl,databody,httpOptions);
    
   
  }
  addPersonImageFile(file:File,url:string):Observable<any>{
    const httpOptionsUpload = {
      headers: new HttpHeaders({
        'Content-Type': file.type || 'application/octet-stream',
      }),
      withCredentials: true,
    }
    return this.http.put(url,file,httpOptionsUpload);
    
    
  }
  getSignedUploadUrl(filename:string):Observable<any>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const body = JSON.stringify({ Key: filename, kind: 'person' });
    return this.http.post<any>(environment.apiUrl+'/logostore/getsignedurl',body,httpOptions);
  }

  getPersonImageDB(personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.personUrl}`+personId+'/image';
    return this.http.get<any>(urlCombo,httpOptions);
  }

  deletePersonImage(){
    //TODO
  }
}
